import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { Route } from "@route-types/Newsletter/Unsubscribe/+types/UnsubscribePage";
import { fetchUnsubscribePageData } from "@routes/Newsletter/Unsubscribe/UnsubscribePage.server";
import UnsubscribePageContent from "@routes/Newsletter/Unsubscribe/UnsubscribePageContent";
import { UnsubscribePageContext } from "@routes/Newsletter/Unsubscribe/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

const UnsubscribePage = (): React.ReactElement => {
  const context = useLoaderData<UnsubscribePageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <UnsubscribePageContent />;
};

export default UnsubscribePage;

export const loader = async () => await fetchUnsubscribePageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as UnsubscribePageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
